import styled from '@emotion/styled'

import { mediaQueryUp } from '~/theme/utils/grid'
import { h3, h4, h5, h6, HeadingEyebrow } from '~/theme/utils/typography'

export const Wrapper = styled.div`
  padding-bottom: 32px;
  display: flex;
  flex-direction: column;
  border-bottom: 1px solid ${({ theme }) => theme.colors.gray[200]};
  gap: 16px;

  &:last-child {
    padding-bottom: 0;
    border-bottom: none;
  }

  ${mediaQueryUp('m')} {
    gap: 8px;
  }
`

export const DescriptionContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 4px;
`

export const ChmInfo = styled.div`
  display: flex;
  flex-direction: column-reverse;
  gap: 24px;

  ${mediaQueryUp('m')} {
    flex-direction: row;
    align-items: center;
    justify-content: space-between;
    gap: 32px;
  }
`

export const Eyebrow = styled(HeadingEyebrow)`
  color: ${({ theme }) => `${theme.colors.gray[600]}`};
  text-transform: uppercase;
`

export const Name = styled.h3`
  ${props => h4({ ...props, fontWeight: 'semiBold' })}

  ${mediaQueryUp('m')} {
    ${props => h3({ ...props, fontWeight: 'semiBold' })}
  }
`

export const Description = styled.div`
  ${props => h6({ ...props, fontWeight: 'regular' })}

  ${mediaQueryUp('m')} {
    ${props => h5({ ...props, fontWeight: 'regular' })}
  }
`

export const PhotoWrapper = styled.div`
  height: auto;
  width: 100%;

  img {
    border-radius: 8px;
  }

  ${mediaQueryUp('m')} {
    height: 120px;
    width: 213px;
  }
`
